import React from "react";

import { Box, IconButton, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";

import ToolbarItem from "./ToolbarItem";

const PageToolbar = ({ noSearch, items, onToolItemClick }) => {
  const theme = useTheme();

  return (
    <Box
      backgroundColor={theme.palette.primary.main}
      height="50px"
      display="flex"
      alignItems="center"
      paddingLeft="10px"
      paddingRight="10px"
      justifyContent="space-between"
    >
      {items && items.length > 0 ? (
        <Box
          display="flex"
          gap={1}
        >
          {items.map((item) => (
            <ToolbarItem
              key={item.name}
              name={item.name}
              label={item.label}
              iconName={item.iconName}
              onClick={onToolItemClick}
              hide={Boolean(item.hide)}
            />
          ))}
        </Box>
      ) : (
        <Box></Box>
      )}
    </Box>
  );
};

export default PageToolbar;
